import React, {forwardRef} from 'react';
import {Platform, View} from 'react-native';

import {CalendarIcon} from '../../components/icons';
import DatePickerModal from '../../components/ui-controls/DatePickerModal';
import TextInput from '../../components/ui-controls/form/TextInput';
import Text, {fontFamily} from '../../components/ui-controls/Text';
import DatePicker from '../../components/ui-controls/web/DatePicker';
import {getTodayAt0Hours} from '../../utils/date';

const EmptyComponent = forwardRef((_, __) => <></>);
const TmpFormLabel = ({label}: {label: string}) => (
  <TextInput
    label={label}
    InputComponent={EmptyComponent}
    renderErrorMessage={false}
    inputContainerStyle={{borderBottomWidth: 0}}
  />
);
type TmpDatePickerProps = {
  error?: string;
  isNativeDialogOpen: boolean;
  label: string;
  nativeMinimumDate: Date;
  nativeText: string;
  onCancel: () => void;
  onChange: (date: Date) => void;
  onNativePressIn: () => void;
  testID?: string;
  value: Date;
};
const TmpDatePicker = ({
  error,
  isNativeDialogOpen,
  label,
  nativeMinimumDate,
  nativeText,
  onCancel,
  onChange,
  onNativePressIn,
  testID,
  value,
}: TmpDatePickerProps) => (
  <>
    {Platform.OS === 'web' ? (
      <>
        <TmpFormLabel label={label} />
        <View style={{paddingHorizontal: 10}} testID={testID}>
          <DatePicker
            value={value}
            onChange={onChange}
            style={{
              height: 40,
              borderTopWidth: 0,
              borderRightWidth: 0,
              borderLeftWidth: 0,
              borderBottomWidth: 1,
              borderBottomColor: 'rgb(134, 147, 158)',
              fontFamily,
              fontSize: 18,
            }}
          />
        </View>
      </>
    ) : (
      <>
        <DatePickerModal
          open={isNativeDialogOpen}
          date={value || getTodayAt0Hours()}
          onConfirm={onChange}
          onCancel={onCancel}
          mode="date"
          title={null}
          minimumDate={nativeMinimumDate}
        />
        <TextInput onPressIn={onNativePressIn} leftIcon={<CalendarIcon />} testID={testID}>
          {nativeText}
        </TextInput>
      </>
    )}
    {!!error && (
      <Text
        style={{
          marginVertical: 5,
          marginHorizontal: 15,
          fontSize: 12,
          color: 'rgb(255, 25, 12)',
        }}>
        {error}
      </Text>
    )}
  </>
);

export default TmpDatePicker;
